export default "__VITE_PUBLIC_ASSET__4d575f9e__"